/* eslint-disable react/prop-types */
import ReserchForm from "./reserch-form";
import Flex from "@/components-library/layout/flex";
import classes from "./build-your-solution.module.scss";
import Filters from "./filters";

//import classNames from "classnames";
import * as annoucementSlice from "./build-your-solution.slice";
import AnnouncementList from "@/common/components/announcement-list";

function BuildYourSolution({ announcements, status, listRef, onSearchClick }) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      <ReserchForm onSearchClick={onSearchClick} />
      <Filters
        isEnabled={status === annoucementSlice.Status.FOUND}
        nElements={announcements?.length}
        className={classes.list}
        listRef={listRef}
      />
      <AnnouncementList
        announcements={announcements}
        status={status}
        admin={false}
      />
    </Flex>
  );
}

export default BuildYourSolution;
